<template>
  <div class="technology">
    <div class="technology__bg" :style="{ backgroundImage: `url('${image}')` }">
    </div>
    <div class="technology__innerwrap">
      <div class="technology__content-wrap">
        <h1 class="technology__title" v-html="benefit.title"></h1>
        <div class="technology__content">
          <ul>
            <li v-for="(item, index) in benefit.list" :key="index" v-html="item"></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Technology',
  props: ['benefit'],
  computed: {
    image() {
      return `static/${this.benefit.image}`;
    },
  },
};
</script>

<style lang="scss">
@import '../../styles/helpers';

.technology {
  @include section;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 60px);

  &__bg {
    background-size: cover;
    background-position: center;
    display: block;
    margin-top: -$section-padding-top;
    flex-grow: 1;
    position: relative;

    &::after {
      content: '';
      display: block;
      width: 349px;
      height: 332px;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      background-image: url('../../assets/technology_circle.svg');
      position: absolute;
      bottom: -190px;
      right: 170px;
    }
  }

  &__innerwrap {
    flex-shrink: 0;
    padding-bottom: 10px;
  }

  &__content-wrap {
    // width: calc(6/12 * 100% + 50px);
  }

  &__title {
    @include font-heading;
  }

  &__content {
    @include font-content;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/templates/Technology.vue